import React from 'react'

import Qn2cFeatureLayout from 'components/pages/quarantineAction/Qn2cFeatureLayout'
import useQn2cFeatureLogic from 'components/pages/quarantineAction/useQn2cFeatureLogic'

export const Qn2cFeature = () => {
  const logic = useQn2cFeatureLogic()
  return <Qn2cFeatureLayout logic={logic} />
}
